import { QueryClientProvider, useQueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { queryClient } from "../api/query-client";
import { Spinner } from "../components/spinner";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type AppProviderProps = {
    children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
    return (
        <React.Suspense fallback={<Spinner />}>
            {/* <ErrorBoundary FallbackComponent={MainErrorFallback}> */}
            <QueryClientProvider client={queryClient}>
                {import.meta.env.DEV && <ReactQueryDevtools />}
                {children}
                <ToastContainer position="bottom-center" />
            </QueryClientProvider>
            {/* </ErrorBoundary> */}
        </React.Suspense>
    );
};
